module.exports = __webpack_public_path__ + "static/media/members2.ea86723f.jpg";